import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import LoadingSpinner from './components/LoadingSpinner.tsx';
import './index.css';

const App = lazy(() => import('./App.tsx'));
const DocsApp = lazy(() => import('./docs/DocsApp.tsx'));
const FlowRoot = lazy(() => import('./flow/index.tsx'));

const pathname = window.location.pathname;
const isDocs = pathname.startsWith('/docs');
const isFlow = pathname.startsWith('/flow');

function getApp() {
  if (isDocs) return <DocsApp />;
  if (isFlow) return <FlowRoot />;
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner message="Loading..." />}>
        {getApp()}
      </Suspense>
    </ErrorBoundary>
  </StrictMode>
);
